import styled from 'styled-components';
import { Div, RowDiv, theme } from 'styles';

export const DateDiv = styled(RowDiv)`
  margin: 32px 0;
  justify-content: space-between;
  align-items: flex-end;
`;

export const TimeWrap = styled(Div)`
  margin-top: 32px;
`;

export const TableWrap = styled(Div)`
  width: 100%;
  overflow-x: auto;
  padding-bottom: 10px;
`;

export const BorderDiv = styled(Div)`
  border: 1px solid ${theme.colors.gray300};
  border-radius: 6px;
  width: 100%;
  max-height: 297px;
  overflow-y: auto;
`;

export const TimeTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-style: hidden;

  td {
    border: 1px solid ${theme.colors.gray300};
    text-align: center;
  }
`;

export const TableTh = styled.th`
  color: ${theme.colors.primary600};
  border: 1px solid ${theme.colors.gray300};
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  padding: 8px 4.5px;
  min-width: 52px;
`;
